import { useState, useEffect, useRef } from "react";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import CustomDropdown from "../../component/CustomDropdown";
import FileUpload from "../../component/SvgIcons/FileUpload";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IconKey from "../../component/SvgIcons/IconKey";
import { motion, AnimatePresence } from "framer-motion";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import IconClose from "../../component/SvgIcons/IconClose";
import utils, { emailPattern, phonePattern } from "../../utils/utils";
import IconError from "../../component/SvgIcons/IconError";

const agentcompanydata = [
  { value: "", label: "Select Company", disabled: true },
  { value: "Global Assist", label: "Global Assist" },
  { value: "Field Assist", label: "Field Assist" },
  { value: "Gulf Konnect", label: "Gulf Konnect" },
  { value: "Gulf Oil", label: "Gulf Oil" },
  { value: "Global Gulf Support", label: "Global Gulf Support" },
];

export default function EditAgentsDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { alert } = useSwal();
  const agent = location.state?.agent;
  console.log("Agent data:", agent);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    agentCompany: "",
    Extensions_Number: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    utils.saveRecentSearch("Edit Agent Details", window.location.pathname);
  }, []);

  useEffect(() => {
    if (agent) {
      setFormData({
        name: agent.Agent_Name || "",
        email: agent.Email_Id || "",
        //password: agent.Password || "",
        password: "",
        phone: agent.Phone_No || "",
        agentCompany: agent.Agents_Company || "",
      
        Extensions_Number: agent.Extensions_Number || "",
      });     
      
      if (agent?.Images) {
        const baseUrl = process.env.REACT_APP_IMAGE_URL || "";
        const imagePath = agent.Images.startsWith("/upload")
          ? agent.Images
          : `/upload/${agent.Images.replace(/^\/+/, "")}`;
        setImagePreview(`${baseUrl}${imagePath}`);
      }
    }
  }, [agent]);

  const getFieldError = (name, value) => {
    switch (name) {
      case "name":
        return !value?.trim() ? "Name is required." : "";
      case "email":
        if (!value?.trim()) return "Email is required.";
        return emailPattern(value.trim()) ? "" : "Invalid email address.";
      case "password":
         if (value && value.length < 6) return "Password must be at least 6 characters.";
         return "";
      case "phone":
        if (!value?.trim()) return "Phone number is required.";
        return phonePattern(value.trim()) ? "" : "Invalid phone number.";
      case "agentCompany":
        return !value ? "Agent company is required." : "";
      default:
        return "";
    }
  };

  const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const requiredFields = ["name", "email", "phone", "agentCompany"];
  let newErrors = {};
  let isValid = true;

  requiredFields.forEach((field) => {
    const error = getFieldError(field, formData[field]);
    if (error) {
      isValid = false;
      newErrors[field] = error;
    }
  });

  // Also validate password only if user entered something
 if (formData.password) {
    const pwdError = getFieldError("password", formData.password);
    if (pwdError) {
      isValid = false;
      newErrors.password = pwdError;
    }
  }
  setFormErrors(newErrors);

  if (!isValid) {
    setLoading(false);
    return;
  }

  const payload = new FormData();
  payload.append("Code", agent.Code);
  payload.append("Agent_Name", formData.name);
  payload.append("Email_Id", formData.email);
  payload.append("Phone_No", formData.phone);
  payload.append("Extensions_Number", formData.Extensions_Number);
  //payload.append("Password", formData.password);
  payload.append("User_Type", "Agent");
  payload.append("Agents_Company", formData.agentCompany);

   // Append password only if entered
  if (formData.password) {
    payload.append("Password", formData.password);
  }

  if (imageFile) {
    payload.append("Images", imageFile);
  } else if (!imagePreview) {
    payload.append("Images", "");
  }

  try {
    const response = await api.post("/editagent", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    console.log("Edit Agent Response:", response.data.data);
    const { success: rawSuccess, message = "Agent updated successfully" } = response.data;
    const success = rawSuccess === true || rawSuccess === "true" || rawSuccess === 1;

    if (success) {
      await alert("success", message);
      setTimeout(() => navigate("/manage-agents"), 1000);
    } else {
      await alert("error", message || "Update failed");
    }
  } catch (error) {
    const message = error.response?.data?.message || "Something went wrong while updating the agent";
    await alert("error", message);
  } finally {
    setLoading(false);
  }
};

return (
    <div className="dashboard">
      <Header title subtitle="Edit Agent Details" backbtn="/manage-agents" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span>Edit Agent Details</span>
            </h2>

            <AnimatePresence mode="wait">
              <motion.form
                onSubmit={handleSubmit}
                className="myform d-flex flex-column justify-content-between"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="create-form d-flex flex-column">
                  <div className="form-row d-flex flex-wrap flex-column flex-lg-row">
                    <div className={`form-group ${formErrors.name ? "fieldrequire" : ""}`}>
                      <label>
                        Name <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter Name"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                      <small className="hide"><IconError /></small>
                    </div>

                    <div className={`form-group ${formErrors.email ? "fieldrequire" : ""}`}>
                      <label>
                        E-Mail ID <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter E-Mail ID"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      <small className="hide"><IconError/></small>
                    </div>

                    <div className={`form-group ${formErrors.password ? "fieldrequire" : ""}`}>
                      <label>
                        Password <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="form-control"
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                      <Link
                        className="hereshowpassword tranparenteffect"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowPassword(!showPassword);
                        }}
                      >
                        <IconKey />
                      </Link>
                      <small className="hide" style={{right:"45px"}}><IconError/></small>
                    </div>
                  </div>

                  <div className="form-row d-flex flex-wrap flex-column flex-lg-row">
                   <div className={`form-group ${formErrors.phone ? "fieldrequire" : ""}`}>
                      <label>
                        Phone Number <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        value={formData.phone}
                        onChange={handleInputChange}
                        inputMode="numeric"
                        onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " "];
                          const allowedChars = /^[\d+\-\s]$/;                            
                          if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
                            return;
                          }                            
                          if (!allowedChars.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}                          
                      />
                      <small className="hide"><IconError/></small>
                    </div>

                    <div className="form-group">
                      <label>
                        Agent Type <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="usertypes"
                        className="form-control"
                        value="Agent"
                        readOnly
                      />
                    </div>

                     <div className={`form-group ${formErrors.agentcompany ? "fieldrequire" : ""}`}>
                      <label>
                        Agents Company <span className="required-asterisk">*</span>
                      </label>
                      <CustomDropdown
                        options={agentcompanydata}
                        value={formData.agentCompany}
                        onChange={(val) => handleDropdownChange("agentCompany", val)}
                        placeholder="Select Agents Company"
                        name="agentCompany"
                      />
                       <small className="hide" style={{right:"40px"}}><IconError/></small>
                    </div>
                  </div>


  <div className="form-row d-flex justify-content-start justify-content-lg-between  flex-wrap flex-xl-nowrap flex-column flex-lg-row">         

          <div className={`form-group`}>
                      <label>Extensions number  </label>
                      <input
                        type="text"
                        name="Extensions_Number"
                        className="form-control"
                        placeholder="Enter extensions number"
                        value={formData.Extensions_Number}
                        onChange={handleInputChange} 
                        // maxLength={10}
                        inputMode="numeric"
                        onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " "];
                          const allowedChars = /^[\d+\-\s]$/;                            
                          if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
                            return;
                          }                            
                          if (!allowedChars.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}                         
                      />
                      <small className="hide"><IconError/></small>
                    </div>

                  <div className="form-group d-flex justify-content-center gap-3 flex-column flex-md-row">
                    <div className="pictureupload">
                      <input
                        ref={fileInputRef}
                        type="file"
                        name="picture"
                        accept=".jpg, .jpeg, .png, .webp"
                        className="custom-file-input position-absolute visually-hidden z-index-1"
                        id="inputGroupFile01"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSelectedFile(file);
                          setImageFile(file);
                        }}
                      />
                      <label
                        className="custom-file-label d-flex align-items-center justify-content-center"
                        htmlFor="inputGroupFile01"
                        style={{ color: "#fff" }}
                      >
                        <FileUpload /> Upload Agent Picture
                      </label>
                    </div>

                    <AnimatePresence>
                      {(selectedFile || imagePreview) && (
                        <motion.div
                          className="selected-file d-flex align-items-center justify-content-center gap-2"
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.3 }}
                        >
                          <a
                            href={selectedFile ? URL.createObjectURL(selectedFile) : imagePreview}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mb-0 text-decoration-underline text-primary"
                            style={{ cursor: "pointer", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title={selectedFile ? selectedFile.name : imagePreview.split("/").pop()}
                          >
                            {selectedFile
                              ? selectedFile.name.length > 25
                                ? `${selectedFile.name.slice(0, 25)}...`
                                : selectedFile.name
                              : imagePreview.split("/").pop()}
                          </a>
                          <button
                            type="button"
                            className="btn p-0"
                            onClick={() => {
                              setSelectedFile(null);
                              setImageFile(null);
                              setImagePreview("");
                              if (fileInputRef.current) fileInputRef.current.value = "";
                            }}
                          >
                            <IconClose />
                          </button>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>  </div>
                </div>

                <div className="form-savebtns d-flex justify-content-end flex-row align-items-center">
                  <Link to="/manage-agents" className="btn cancelbtn">Back</Link>
                  <button type="submit" className="btn btngradiant" disabled={loading}>
                    {loading ? "Update..." : "Update"}
                  </button>
                </div>
              </motion.form>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
